<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col>
        <base-material-card icon="mdi-account-group">
          <template v-slot:heading>
            <h3 class="display-2">Monitoring Validasi</h3>
          </template>
          <v-row>
            <v-col>
              <crud
              :crudSettings="crudSettings"
              :headers="headers"
              :responseData="{data:items}"
              :detailData="detailData"
              :forceUpdateTable="forceUpdate"
              @onTableChange="updateTable"
              >
              <template v-slot:prepend-header>
                <v-select style="max-width:200px" label="SKPD" hide-details class="mx-2"></v-select>
                <v-divider class="mx-2" inset vertical/>
                <v-select style="max-width:200px" :items="months" label="Bulan" hide-details class="mx-2"></v-select>
                <v-divider class="mx-2" inset vertical/>
              </template>
            </crud>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {months} from '@/utils/lib'
import _ from 'lodash'
import Crud from '@/components/common/Crud'

export default {
  components:{
    Crud,
  },

  data(){
    return{
      forceUpdate:false,
      loading:false,
      detailData:{},

      headers:[
        {text:'No', value:'no', sortable:false, class:'header-index-profile'},
        {text:'Nip-Nama', value:'nama_peg', sortable:false, class:'header-index-profile'},
        {text:'Jabatan', value:'jbt', sortable:false, class:'header-index-profile'},
        {text:'Jumlah Bawahan', value:'jml', sortable:false, class:'header-index-profile'},
        {text:'Sudah Divalidasi', value:'sdh', sortable:false, class:'header-index-profile'},
        {text:'Belum Divalidasi', value:'blm', sortable:false, class:'header-index-profile'},
      ],
      items:[
        {
          no:'1', nama_peg:'A ADELIA MARYANI - 197303221992032001',jbt:'Kepala Seksi Kesejahteraan Sosial Kec. Bandung Wetan', jml:1, sdh:0, blm:0
        }
      ],

      dialogReset:false,
      crudSettings:{
        title:'',
        detailTitle:'Detail',
        enableHeader:true,
        enableDetail:false,
        enableCreate:false,
      },
    }
  },

  watch:{},

  created(){
    let val = {itemsPerPage:10, page: 1}
    this.updateTable(val)
  },

  computed:{
    months(){
      return months
    }
  },

  methods:{
    getImg(nip,ext){
      if (nip){
        let avatarImgUrl = process.env.VUE_APP_IMG_URL + nip +"."+ext
        // this.avatarImages[nip] = avatarImgUrl
        return avatarImgUrl
      }
      return ''
    },

    updateTable(val){},
  },
}
</script>

<style lang="css" scoped>
</style>
